//Created by wangshuyi on 2020-02-02.

'use strict';

import routerConfig from "./routeConfig";
import router from '@/router/index';

const mock = false;

const RouterUtil = {
  // 添加动态路由
  addAccessRoute(menuList = router.app.$store.state.menuList) {
    for (const menu of menuList) {
      if (menu.SYS_TYPE !== 20011003) {
        return;
      }
      if (!menu.CLASS_NAME) continue;
      menu.CLASS_NAME = menu.CLASS_NAME.trim();
      const route = {
        path: menu.ASSEMBLY,
        name: menu.MENU_NAME + menu.MENU_ID,
        component: (resolve) => require([`@/views${menu.CLASS_NAME}.vue`], resolve)
      };
      router.addRoute(route);
    }
  },

  // 已完成登录
  hasLoginAndCompanyApproved($vue, to){
    if($vue.$store.state.userInfo && !$vue.$store.state.isVisitor && $vue.$store.state.companyCheckFlag){
      return Promise.resolve();
    }else{
      return Promise.reject();
    }
  },
  // 访客 + 访客白名单
  checkVisitorUrl($vue, to){
    if($vue.$store.state.userInfo && $vue.$store.state.isVisitor){
      if(this.checkUrlWhite(to)){
        return Promise.resolve();
      }else{
        return Promise.resolve('/index');
      }
    }else{
      return Promise.reject();
    }
  },
  // 用户 + 没企业
  checkUserAndNoCompany($vue, to){
    if($vue.$store.state.userInfo && !$vue.$store.state.isVisitor && !$vue.$store.state.userInfo.COMPANY_ID){
      if(this.checkUrlWhite(to) || this.checkCompanyUrlWhite(to)){
        return Promise.resolve();
      }else{
        return Promise.resolve('/registerSuccess');
      }
    }else{
      return Promise.reject();
    }
  },
  // 用户 + 企业未通过审批
  checkUserAndCompanyChecking($vue, to){
    if($vue.$store.state.userInfo && !$vue.$store.state.isVisitor && $vue.$store.state.userInfo.COMPANY_ID && !$vue.$store.state.companyCheckFlag){
      if(this.checkUrlWhite(to) || this.checkCompanyUrlWhite(to)){
        return Promise.resolve();
      }else{
        return Promise.resolve('/registerDetail');
      }
    }else{
      return Promise.reject();
    }
  },



  checkLogin($vue, to) {
    return new Promise((resolve, reject) => {
      if (to.query.USER_ID && $vue.$store.state.isVisitor) {
        reject();
      }
      $vue.$store.state.userInfo ? resolve() : reject();
    });
  },
  checkIsVisitor($vue, to){
    if($vue.$store.state.isVisitor){
      return Promise.resolve();
    }else{
      return Promise.reject();
    }
  },
  checkCompanyApproved($vue, to){
    if($vue.$store.state.companyCheckFlag){
      return Promise.resolve();
    }else{
      return Promise.reject();
    }
  },
  checkHasCompany($vue, to){
    if($vue.$store.state.userInfo && $vue.$store.state.userInfo.COMPANY_ID){
      return Promise.resolve();
    }else{
      return Promise.reject();
    }
  },

  autoLogin($vue, to) {
    return new Promise((resolve, reject) => {
      this.loginBySessionStorage($vue, to).then(reData => resolve(to.path)).catch(() => {
        // console.log('通过cookie自动登录');
        //通过cookie自动登录
        return $vue.$store.dispatch('autoLoginByCookie');
      }).then(() => resolve(to.path)).catch(() => {
        // console.log('通过USER_ID自动登录');
        //通过USER_ID自动登录
        if (to.query.USER_ID) {
          return $vue.$store.dispatch('autoLoginById', to.query.USER_ID);
        } else {
          return Promise.reject();
        }
      }).then(() => resolve(to.path)).catch(() => {
        // console.log('通过code自动登录');
        //通过code自动登录
        if (to.query.code) {
          return this.loginByCode($vue, to);
        } else {
          return Promise.reject();
        }
      }).then(() => resolve(to.path)).catch(() => {
        // console.log('游客自动登录');
        // 游客自动登录
        if (!to.query.USER_ID) {
          return $vue.$store.dispatch('login', { username: 'testCargo', password: 'testCargo' });
        } else {
          return Promise.reject();
        }
      }).then(() => resolve(to.path)).catch(() => {
        //通过mock自动登录
        if (mock || to.query.mock) {
          return $vue.$store.dispatch('autoLoginByMock');
        } else {
          return Promise.reject();
        }
      }).then(() => resolve(to.path)).catch(() => {
        //未登录
        reject();
      });
    });
  },

  loginBySessionStorage($vue, to) {
    return new Promise((resolve, reject) => {
      $vue.$store.commit('init');
      if (to.query.USER_ID && $vue.$store.state.isVisitor) {
        reject();
      }
      ($vue.$store.state.userInfo && !$vue.$store.state.isVisitor) ? resolve() : reject();
    });
  },
  loginByCode($vue, to) {
    if (to.query.state === "workWx") {
      return $vue.$store.dispatch('autoLoginByWorkWeChatCode', to.query.code);
    } else {
      return Promise.reject();
    }
  },

  //校验访问地址是否为白名单地址
  checkUrl(to) {
    let flag;
    switch (routerConfig.authType) {
      case "white":
        flag = this.checkUrlWhite(to);
        break;
      case "black":
        flag = this.checkUrlBlock(to);
        break;
      default:
        flag = false;
    }
    if (flag) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
  checkUrlWhite(to) {
    let flag = false;
    routerConfig.whiteList.forEach(pathRule => {
      if (pathRule.test(to.path)) {
        flag = true;
      }
    });
    return flag;
  },
  checkNoCompanyWhiteUrl(to) {
    let flag = false;
    routerConfig.whiteList.forEach(pathRule => {
      if (pathRule.test(to.path)) {
        flag = true;
      }
    });
    return flag;
  },
  checkCompanyUrlWhite(to) {
    let flag = false;
    routerConfig.companyUnapprovedList.forEach(pathRule => {
      if (pathRule.test(to.path)) {
        flag = true;
      }
    });
    return flag;
  },
  checkUrlBlock(to) {
    let flag = true;
    routerConfig.blackList.forEach(pathRule => {
      if (pathRule.test(to.path)) {
        flag = false;
      }
    });
    return flag;
  },
  getDefaultPage(url, query) {
    let sep = '?';
    for (let key in query) {
      url += sep + key + '=' + query[key];
      sep = '&';
    }
    return url;
  },

  checkAuthPath($vue, to) {
    if ($vue.$store.state.companyCheckFlag && !$vue.$store.state.isVisitor) {
      return Promise.resolve();
    } else if (to.path === '/index' || to.path === '/') {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },

  checkCompanyUrl($vue, to){
    if(this.checkUrlWhite(to) || this.checkCompanyUrlWhite(to)){
      return Promise.resolve();
    }else{
      return Promise.reject();
    }
  },
};

export default RouterUtil;
